import instance from '../axios';

export const getAll = async () => {
  const response = await instance.get(`goods-receipts`);
  return response.data;
};

export const getPOs = async () => {
  const response = await instance.get(`goods-receipts/po`);
  return response.data;
};
export const getDetails = async (id) => {
  const response = await instance.get(`goods-receipts/` + id);
  return response.data;
};
export const insert = async (data) => {
  const response = await instance.post(`goods-receipts`, data);
  return response;
};
export const update = async (data) => {
  const response = await instance.put(`goods-receipts`, data);
  return response;
};
export const remove = async (id) => {
  const response = await instance.delete(`goods-receipts/` + id);
  return response;
};
